import { client } from '@repo/api-kit/queries/utils';
import {
  registerPartnersBaseURL,
  registerPartnersNamespace,
} from '@repo/runtime-kit/constants/hosts';

import type {
  PaymentIntent,
  PaymentIntentAdapter,
} from '@repo/customer-registration-kit/capital-deposit/components/stripe-card-form/types';

interface BackendPaymentIntentResponse {
  data: {
    id: string;
    type: 'payment_intents';
    attributes: {
      client_secret: string;
      requires_action: boolean;
    };
  };
}

interface CreateRegisterPartnersPaymentIntentAdapterParams {
  registrationId: string;
}

export function createRegisterPartnersPaymentIntentAdapter({
  registrationId,
}: CreateRegisterPartnersPaymentIntentAdapterParams): PaymentIntentAdapter {
  const baseUrl = `${registerPartnersBaseURL}/${registerPartnersNamespace}`;

  return {
    async createPaymentIntent({ paymentMethodId, pricePlanId }) {
      const response = await client<BackendPaymentIntentResponse>(`${baseUrl}/payment_intents`, {
        method: 'POST',
        body: JSON.stringify({
          data: {
            type: 'payment_intents',
            attributes: {
              price_plan_id: pricePlanId,
              payment_method_id: paymentMethodId,
            },
            relationships: {
              registration: {
                data: { type: 'registrations', id: registrationId },
              },
            },
          },
        }),
      });

      return toPaymentIntent(response);
    },

    async confirmPaymentIntent(intentId) {
      const response = await client<BackendPaymentIntentResponse>(
        `${baseUrl}/payment_intents/${intentId}/confirm`,
        { method: 'POST' }
      );

      return toPaymentIntent(response);
    },
  };
}

function toPaymentIntent({ data }: BackendPaymentIntentResponse): PaymentIntent {
  return {
    id: data.id,
    clientSecret: data.attributes.client_secret,
    requiresAction: data.attributes.requires_action,
  };
}
